import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

export type ContainerRelocationDragSource = {
  kind: 'container' | 'item';
  id: string;
};

export type ContainerRelocationDragState = {
  clientX: number;
  clientY: number;
  pointerId: number;
  source: ContainerRelocationDragSource;
};

@Injectable({
  providedIn: 'root',
})
export class ContainerRelocationDragService {
  private readonly stateSubject = new BehaviorSubject<ContainerRelocationDragState | null>(null);

  readonly state$ = this.stateSubject.asObservable();

  start(state: ContainerRelocationDragState): void {
    this.stateSubject.next(state);
  }

  move(pointerId: number, clientX: number, clientY: number): void {
    const current = this.stateSubject.value;
    if (!current || current.pointerId !== pointerId) {
      return;
    }

    this.stateSubject.next({...current, clientX, clientY});
  }

  end(pointerId?: number): void {
    const current = this.stateSubject.value;
    if (!current || (pointerId !== undefined && current.pointerId !== pointerId)) {
      return;
    }

    this.stateSubject.next(null);
  }
}
